import BackButton from "../components/BackButton";
import { All } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { initialAppState } from "../common/reducers/appState";

export function mapStateToProps({ routerHistory, appState }: All) {
  return {
    backButtonURL: routerHistory.backButtonHist,
    currentApp: appState.app,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (app: string) => {
      dispatch(actions.resetState((initialAppState as any)[app]));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BackButton);
